import React, { useEffect } from 'react'
import type { ProductType } from 'src/components/product/ProductCard/ProductCardTypes'
import { useBuyTogetherSelection } from 'src/contexts/InsiderBuyTogetherContext/InsiderBuyTogetherContext'
import type { Buyable } from 'src/contexts/InsiderBuyTogetherContext/InsiderBuyTogetherContext'
import { InsiderPriceTag } from '../../InsiderShelf/InsiderPriceTag/InsiderPriceTag'
import { sanitizeUrl } from 'src/utils/sanitizeUrl'
import '../styles.scss'

interface Props {
  product: ProductType
  index: number
  defaultSelected?: boolean
}

export default function InsiderBuyTogetherDefaultProductCard({
  product,
  index,
  defaultSelected = false,
}: Props) {
  const offer = product?.offers?.offers?.[0]

  const { selected, toggleSelection } = useBuyTogetherSelection()

  const id = product?.sku ?? ''
  const price = offer ? offer?.price : 0
  const buyable: Buyable = { id, price, raw: product }

  const isSelected = Boolean(selected[id])
  const productUrl = product?.slug
  const changeUrl = sanitizeUrl(false, productUrl)

  useEffect(() => {
    if (defaultSelected && !isSelected) {
      toggleSelection(buyable)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={`insider-product-card-bt ${isSelected ? 'selected' : ''}`}>
      <div className="buytogether-radio">
        <input
          type="checkbox"
          checked={isSelected}
          onChange={() => toggleSelection(buyable)}
        />
      </div>

      <a href={changeUrl} className="ins-web-smart-recommender-box-item">
        <div
          className="ins-product-box ins-element-link ins-add-to-cart-wrapper ins-sr-api"
          ins-product-id={product.sku ?? 'unknown'}
          event-collection="true"
        >
          <div className="wrapper-wishlist-image-bt">
            <figure className="product-image-bt">
              <img
                src={product.image?.[0]?.url ?? '/placeholder.png'}
                alt={product.name ?? 'Produto sem nome'}
                loading="lazy"
              />
            </figure>
          </div>

          <div className="product-info-wrapper-bt">
            <div className="product-name-bt">{product?.name}</div>
            <InsiderPriceTag
              listPrice={offer?.listPrice}
              price={offer?.price}
            />
          </div>
        </div>
      </a>
    </div>
  )
}
